import { ITranslations } from 'types/common';
import en from 'translations/en/categories.json';
import pl from 'translations/pl/categories.json';
import sl from 'translations/sl/categories.json';
import { CategoriesTransFields } from './types';

export const categoriesTranslations: ITranslations<CategoriesTransFields> = {
  name: 'categories',
  en,
  pl,
  sl,
};
